 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"CompetitionsComponent~CompotitionDashboard~RegisterWithEmail~clubs~competitionStatisticsPage~competi~19f596de":"CompetitionsComponent~CompotitionDashboard~RegisterWithEmail~clubs~competitionStatisticsPage~competi~19f596de","CompetitionsComponent~CompotitionDashboard~clubs~competitionTypePage~dashboard~groupPage~matchReport~f0a5b31c":"CompetitionsComponent~CompotitionDashboard~clubs~competitionTypePage~dashboard~groupPage~matchReport~f0a5b31c","CompetitionsComponent~CompotitionDashboard~clubs~competitionTypePage~dashboard~groupPage~groupStatis~cf639419":"CompetitionsComponent~CompotitionDashboard~clubs~competitionTypePage~dashboard~groupPage~groupStatis~cf639419","CompetitionsComponent~competitionTypePage":"CompetitionsComponent~competitionTypePage","CompetitionsComponent":"CompetitionsComponent","competitionTypePage":"competitionTypePage","CompotitionDashboard~clubs~dashboard~groupPage~matchReport~players~referees~stafflist~teamscomponent":"CompotitionDashboard~clubs~dashboard~groupPage~matchReport~players~referees~stafflist~teamscomponent","CompotitionDashboard":"CompotitionDashboard","clubs":"clubs","dashboard":"dashboard","groupPage":"groupPage","matchReport":"matchReport","players":"players","referees":"referees","teamscomponent":"teamscomponent","stafflist":"stafflist","profile":"profile","RegisterWithEmail":"RegisterWithEmail","competitionStatisticsPage":"competitionStatisticsPage","locations":"locations","login":"login","matchSettings":"matchSettings","spiideoSettings":"spiideoSettings","teampage":"teampage","groupStatisticsPage":"groupStatisticsPage","clubprofile":"clubprofile","competitionPage":"competitionPage","competitionTypesPage":"competitionTypesPage","staffpage":"staffpage"}[chunkId]||chunkId) + "." + {"CompetitionsComponent~CompotitionDashboard~RegisterWithEmail~clubs~competitionStatisticsPage~competi~19f596de":"2212aafe","CompetitionsComponent~CompotitionDashboard~clubs~competitionTypePage~dashboard~groupPage~matchReport~f0a5b31c":"0d99aae4","CompetitionsComponent~CompotitionDashboard~clubs~competitionTypePage~dashboard~groupPage~groupStatis~cf639419":"446072ee","CompetitionsComponent~competitionTypePage":"8e7f2755","CompetitionsComponent":"c4bc6154","competitionTypePage":"3a6d5a8d","CompotitionDashboard~clubs~dashboard~groupPage~matchReport~players~referees~stafflist~teamscomponent":"0828e0eb","CompotitionDashboard":"60071fc6","clubs":"399534d8","dashboard":"6983ab8a","groupPage":"55c7ae8b","matchReport":"f36e1c57","players":"23fbb0a7","referees":"591d5a61","teamscomponent":"60f04531","stafflist":"75ef93ab","profile":"eb6b01bc","RegisterWithEmail":"aa9c91aa","competitionStatisticsPage":"84fa698c","locations":"63203c54","login":"c87f0aac","matchSettings":"a039bf3e","spiideoSettings":"f51e9869","teampage":"8d114277","groupStatisticsPage":"41a1484c","clubprofile":"99067543","competitionPage":"c08b920d","competitionTypesPage":"182348c9","staffpage":"6aeb8656"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"CompetitionsComponent~CompotitionDashboard~RegisterWithEmail~clubs~competitionStatisticsPage~competi~19f596de":1,"CompetitionsComponent~CompotitionDashboard~clubs~competitionTypePage~dashboard~groupPage~matchReport~f0a5b31c":1,"CompetitionsComponent~competitionTypePage":1,"CompetitionsComponent":1,"competitionTypePage":1,"CompotitionDashboard~clubs~dashboard~groupPage~matchReport~players~referees~stafflist~teamscomponent":1,"CompotitionDashboard":1,"clubs":1,"dashboard":1,"groupPage":1,"matchReport":1,"referees":1,"teamscomponent":1,"stafflist":1,"RegisterWithEmail":1,"competitionStatisticsPage":1,"locations":1,"login":1,"spiideoSettings":1,"teampage":1,"groupStatisticsPage":1,"clubprofile":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"CompetitionsComponent~CompotitionDashboard~RegisterWithEmail~clubs~competitionStatisticsPage~competi~19f596de":"CompetitionsComponent~CompotitionDashboard~RegisterWithEmail~clubs~competitionStatisticsPage~competi~19f596de","CompetitionsComponent~CompotitionDashboard~clubs~competitionTypePage~dashboard~groupPage~matchReport~f0a5b31c":"CompetitionsComponent~CompotitionDashboard~clubs~competitionTypePage~dashboard~groupPage~matchReport~f0a5b31c","CompetitionsComponent~CompotitionDashboard~clubs~competitionTypePage~dashboard~groupPage~groupStatis~cf639419":"CompetitionsComponent~CompotitionDashboard~clubs~competitionTypePage~dashboard~groupPage~groupStatis~cf639419","CompetitionsComponent~competitionTypePage":"CompetitionsComponent~competitionTypePage","CompetitionsComponent":"CompetitionsComponent","competitionTypePage":"competitionTypePage","CompotitionDashboard~clubs~dashboard~groupPage~matchReport~players~referees~stafflist~teamscomponent":"CompotitionDashboard~clubs~dashboard~groupPage~matchReport~players~referees~stafflist~teamscomponent","CompotitionDashboard":"CompotitionDashboard","clubs":"clubs","dashboard":"dashboard","groupPage":"groupPage","matchReport":"matchReport","players":"players","referees":"referees","teamscomponent":"teamscomponent","stafflist":"stafflist","profile":"profile","RegisterWithEmail":"RegisterWithEmail","competitionStatisticsPage":"competitionStatisticsPage","locations":"locations","login":"login","matchSettings":"matchSettings","spiideoSettings":"spiideoSettings","teampage":"teampage","groupStatisticsPage":"groupStatisticsPage","clubprofile":"clubprofile","competitionPage":"competitionPage","competitionTypesPage":"competitionTypesPage","staffpage":"staffpage"}[chunkId]||chunkId) + "." + {"CompetitionsComponent~CompotitionDashboard~RegisterWithEmail~clubs~competitionStatisticsPage~competi~19f596de":"efdf31b1","CompetitionsComponent~CompotitionDashboard~clubs~competitionTypePage~dashboard~groupPage~matchReport~f0a5b31c":"9ce8edde","CompetitionsComponent~CompotitionDashboard~clubs~competitionTypePage~dashboard~groupPage~groupStatis~cf639419":"31d6cfe0","CompetitionsComponent~competitionTypePage":"4c604678","CompetitionsComponent":"41547670","competitionTypePage":"423145bc","CompotitionDashboard~clubs~dashboard~groupPage~matchReport~players~referees~stafflist~teamscomponent":"daca5a6e","CompotitionDashboard":"80459469","clubs":"9fc90f8e","dashboard":"80459469","groupPage":"aff3fcb9","matchReport":"672afda3","players":"31d6cfe0","referees":"0c868e43","teamscomponent":"aa0c12e0","stafflist":"b8a2ab3d","profile":"31d6cfe0","RegisterWithEmail":"3c34c9ac","competitionStatisticsPage":"9b491ca9","locations":"83f2bbf8","login":"3c34c9ac","matchSettings":"31d6cfe0","spiideoSettings":"6649c140","teampage":"900e3fae","groupStatisticsPage":"1bea0c41","clubprofile":"0066741b","competitionPage":"31d6cfe0","competitionTypesPage":"31d6cfe0","staffpage":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
